module.exports = __webpack_public_path__ + "img/2.f600da67.png";